import React from "react";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect } from "react-redux";
import { RouteProps, RouterProps } from "react-router";
import { Grid, Typography } from "material-ui";
import { SetShowBackNavigation } from "ducks/common";

interface IAccessibilityPageStateProps {}
interface IAccessibilityPageDispatchProps {
    ShowBackNavigation: () => void;
    HideBackButton: () => void;
}

type IAccessibilityPageProps = IAccessibilityPageDispatchProps &
    RouterProps &
    RouteProps;

class AccessibilityPage extends React.Component<
    IAccessibilityPageProps,
    IAccessibilityPageStateProps
> {
    componentDidMount() {
        this.props.ShowBackNavigation();
    }

    componentWillUnmount() {
        this.props.HideBackButton();
    }

    public render() {
        return (
            <div className="AccessibilityPage">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid
                            className="text-container"
                            item
                            xs={12}
                            sm={10}
                            md={10}
                            lg={10}
                        >
                            <h2>
                                Tervetuloa, tämä on organisaation
                                Hypoteekkiyhdistys saavutettavuusseloste
                            </h2>

                            <Typography>
                                Tämä saavutettavuusseloste koskee palvelua Hypo
                                Mobiilipankki ja on laadittu 11.05.2021.
                                Palvelua koskee laki digitaalisten palvelujen
                                tarjoamisesta, jossa edellytetään, että
                                julkisten verkkopalvelujen on oltava
                                saavutettavia.
                            </Typography>

                            <Typography>
                                Palvelun saavutettavuuden on arvioinut
                                ulkopuolinen asiantuntijaorganisaatio.
                            </Typography>

                            <h3>Digipalvelun saavutettavuuden tila</h3>

                            <Typography>
                                Täyttää kaikki saavutettavuusvaatimukset.
                            </Typography>

                            <h3>
                                Huomasitko saavutettavuuspuutteen
                                digipalvelussamme? Kerro se meille ja teemme
                                parhaamme puutteen korjaamiseksi.
                            </h3>

                            {/* <h4>Verkkolomakkeella</h4>

                            <Typography>
                                Anna saavutettavuuspalautetta tällä
                                verkkolomakkeella LINKKI.
                            </Typography> */}

                            <h4>Sähköpostilla</h4>

                            <Typography>hypo@hypo.fi</Typography>

                            <h3>Valvontaviranomainen</h3>

                            <Typography>
                                Jos huomaat sivustolla saavutettavuusongelmia,
                                anna ensin palautetta meille eli sivuston
                                ylläpitäjälle. Vastauksessa voi mennä 14 päivää.
                                Jos et ole tyytyväinen saamaasi vastaukseen tai
                                et saa vastausta lainkaan kahden viikon aikana,
                                <a
                                    href="https://www.saavutettavuusvaatimukset.fi/oikeutesi/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    voit tehdä ilmoituksen Etelä-Suomen
                                    aluehallintovirastoon
                                    <span className="screen-reader-text">
                                        Avautuu uuteen ikkunaan
                                    </span>
                                </a>
                                . Etelä-Suomen aluehallintoviraston sivulla
                                kerrotaan tarkasti, miten ilmoituksen voi tehdä
                                ja miten asia käsitellään.
                            </Typography>

                            <h3>Valvontaviranomaisen yhteystiedot</h3>
                            <Typography>
                                Etelä-Suomen aluehallintovirasto
                                <br />
                                Saavutettavuuden valvonnan yksikkö
                                <br />
                                www.saavutettavuusvaatimukset.fi <br />
                                saavutettavuus(at)avi.fi
                                <br />
                                puhelinnumero vaihde 0295 016 000
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (_state: ReduxState): IAccessibilityPageStateProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IAccessibilityPageDispatchProps => {
    return {
        ShowBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            return dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityPage);



// WEBPACK FOOTER //
// ./src/views/about/AccessibilityPage.tsx